export default __webpack_public_path__ + "static/media/Custom-Software-Header.cd9a791e.png";